import React, { useState } from 'react';
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Text,
} from '@chakra-ui/react';

const GroupModalMain = ({  text, children }) => {
  const [isOpenModal, setIsOpenModal] = useState(false);

  const handleOpenModal = () => {
    setIsOpenModal(true);
  };

  const handleCloseModal = () => {
    setIsOpenModal(false);
  };

  return (
    <>
      <Button
        onClick={handleOpenModal}
        backgroundColor={'#4945FF'}
        _hover={{ backgroundColor: '#7B79FF' }}
        color="white"
        gap={'5px'}
      >
        <Text>{text}</Text>
        {/* <VscArchive /> */}
      </Button>

      <Modal isOpen={isOpenModal} onClose={handleCloseModal}>
        <ModalOverlay />
        <ModalContent
          fontFamily={"'Jura', sans-serif"}
          backgroundColor={'#212134'}
          color={'white'}
        >
          <ModalHeader>Группы</ModalHeader>
          <ModalCloseButton />
          <ModalBody>{children}</ModalBody>
          <ModalFooter>
            <Button onClick={handleCloseModal}>Закрыть</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default GroupModalMain;
